module.exports = __webpack_public_path__ + "static/media/Background.7b960c92.jpg";